import React, { MouseEvent } from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Text,
  FontWeight,
  Color,
  TextAlign,
  Overflow,
  Button,
  ButtonSize,
  AlignSelf,
} from '@gousto-internal/citrus-react'

import { client } from 'config/routes'

import { EasyCookingSection } from './EasyCookingSection'
import { HowToSection } from './HowToSection'
import { IngredientsSection } from './IngredientsSection'
import { TextBlock } from './TextBlock'
import { SECTION_TITLE, SUMMARY_SECTION } from './data'
import { useGetHowGoustoWorksData } from './howGoustoWorksHooks'

const ContentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  maxWidth: '750px',
  width: '282px',
  alignSelf: 'center',

  '@media (min-width: 375px)': {
    width: '327px',
  },

  '@media (min-width: 640px)': {
    width: '692px',
  },

  '@media (min-width: 959px)': {
    width: '750px',
  },
})

const TextContainerWithPadding = styled.div({
  paddingTop: '32px',

  '@media (min-width: 640px)': {
    paddingTop: '48px',
  },
})

export const HowGoustoWorks = () => {
  const { trackClickGetStartedCTA } = useGetHowGoustoWorksData()

  const onClickGetStarted = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    trackClickGetStartedCTA(client.signup, 'howGoustoWorks')
  }

  return (
    <Box
      width="100%"
      paddingV={[8, 10]}
      paddingH={[4, 6]}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      overflowX={Overflow.Hidden}
      data-testid="HowGoustoWorks"
    >
      <ContentContainer>
        <Text
          fontWeight={FontWeight.Bold}
          color={Color.ColdGrey_800}
          textAlign={TextAlign.Center}
          size={[6, 7]}
        >
          {SECTION_TITLE}
        </Text>

        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          justifyContent={JustifyContent.Center}
          alignItems={AlignItems.Center}
          paddingBottom={0}
          paddingV={6}
          width="100%"
        >
          <HowToSection />
          <IngredientsSection />
          <EasyCookingSection />
        </Box>

        <TextContainerWithPadding>
          <TextBlock title={SUMMARY_SECTION.title} text={SUMMARY_SECTION.text} />
        </TextContainerWithPadding>

        <Box
          paddingBottom={0}
          paddingV={10}
          alignSelf={AlignSelf.Center}
          width="351px"
          maxWidth="351px"
          minWidth="296px"
        >
          <Button onClick={onClickGetStarted} size={ButtonSize.Large} width="100%" height="48px">
            {SUMMARY_SECTION.ctaText}
          </Button>
        </Box>

        <Box paddingBottom={0} paddingV={2}>
          <Text size={2} color={Color.ColdGrey_800}>
            {SUMMARY_SECTION.captionText}
          </Text>
        </Box>
      </ContentContainer>
    </Box>
  )
}
